<template>
  <ibox>
    <template slot="title">企業更新</template>
    <template slot="body">
      <company-form :id="companyId" />
    </template>
  </ibox>
</template>

<script>
  import CompanyForm from '../../components/company/Form.vue'

  export default {
    data () {
      return {
        companyId: this.$route.params.company_id
      }
    },
    components: {
      CompanyForm
    }
  }
</script>




// WEBPACK FOOTER //
// Edit.vue?fbed6dc8